import React from "react";
import { useTranslation } from "react-i18next";
import { Anchor } from "components/Core/Anchor/Anchor";
import { LinkTextProps, LinkText } from "@clearabee/ui-library-native";
import { Platform } from "react-native";

export const SkipLink = ({
  color,
}: {
  color?: LinkTextProps["color"];
}): React.ReactElement => {
  const [translate] = useTranslation();

  return (
    <Anchor
      routeName="ServicePage"
      params={{
        categorySku: "SKIPS",
      }}
      styles={{
        ...(Platform.OS === "ios" ? { marginTop: -5 } : {}),
      }}
    >
      <LinkText
        styles={
          Platform.OS === "android" && {
            position: "absolute",
            left: 0,
            bottom: -7,
          }
        }
        textStyles={{ fontFamily: "ProximaSemiBold" }}
        underline
        color={color}
      >
        {translate("hwa.screens.selectProduct.skipHireLink")}
      </LinkText>
    </Anchor>
  );
};
